import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { FiUsers } from "react-icons/fi";
import { IoIosTrendingUp } from "react-icons/io";
import { MdOutlineWatchLater } from "react-icons/md";
import { VscGraph } from "react-icons/vsc";
import SalesCard from "../../Components/Cards/SalesCard";
import { SubTitle } from "../../Components/CustomComponents";
import AgentProfileScoreCard from "./components/AgentScorecard";
import AgentProfileScoreCardSkeleton from "../../Components/Skeleton/AgentProfileScoreCardSkeleton";

const SalesManagementScreen = () => {
  let bg1 = "#fff";
  let bg2 = "#fff";
  let iconColor = "grey";

  const saleData = {
    // dummy data
    data: {
      saleStats: {
        top_performers: 12,
        avg_rebook_rate: 88,
        total_consultations: 456,
        avg_response_time: 1.8,
      },
    },
  };
  const [dummyFetch, setDummyFetch] = useState({
    isLoading: true,
    isFetching: true,
  });

  useEffect(() => {
    setTimeout(() => {
      setDummyFetch((prev) => {
        return {
          ...prev,
          isLoading: false,
          isFetching: false,
        };
      });
    }, 2000);
  }, []);

  const cardData = [
    {
      icon: <VscGraph color={iconColor} />,
      text: "Top Performers",
      number:
        saleData?.data == null ? 0 : saleData?.data?.saleStats?.top_performers,
      lg: 3,
      bottomText: `Agents about ${4.5} rating`,
    },
    {
      icon: <IoIosTrendingUp color={iconColor} />,
      number:
        saleData?.data == null ? 0 : saleData?.data?.saleStats?.avg_rebook_rate,
      text: "Avg Rebook Rate",
      after_number: "%",
      percentage: "+5%",
      lg: 3,
      bottomText: `Across all agents`,
    },
    {
      icon: <FiUsers color={iconColor} size="20px" />,
      before_number: "$",
      number:
        saleData?.data == null
          ? 0
          : saleData?.data?.saleStats?.total_consultations,
      text: "Total Consultations",
      bottomText: `This month`,
      lg: 3,
    },
    {
      icon: <MdOutlineWatchLater color={iconColor} />,
      after_number: "min",
      number:
        saleData?.data == null
          ? 0
          : saleData?.data?.saleStats?.avg_response_time,
      text: "Avg Response Time",
      bottomText: `Agent response time`,
      isTime: true,
      lg: 3,
    },
  ];

  const teamProfiles = [
    {
      id: 1,
      name: "Sarah Chen",
      monthlyEarnings: "$4,250",
      rebookRate: 87,
      avgRating: 4.9,
      reviews: 156,
      responseTime: "2.3 min",
      isTopPerformer: true,
      imageUrl: "https://randomuser.me/api/portraits/men/1.jpg",
    },
    {
      id: 2,
      name: "Alex Johnson",
      monthlyEarnings: "$3,800",
      rebookRate: 75,
      avgRating: 4.5,
      reviews: 92,
      responseTime: "3.1 min",
      isTopPerformer: false,
      imageUrl: "https://randomuser.me/api/portraits/men/5.jpg",
    },
    {
      id: 3,
      name: "Maria Garcia",
      monthlyEarnings: "$4,920",
      rebookRate: 95,
      avgRating: 5.0,
      reviews: 210,
      responseTime: "1.8 min",
      isTopPerformer: true,
      imageUrl: "https://randomuser.me/api/portraits/men/3.jpg",
    },
    {
      id: 4,
      name: "David Lee",
      monthlyEarnings: "$3,150",
      rebookRate: 62,
      avgRating: 4.2,
      reviews: 55,
      responseTime: "4.5 min",
      isTopPerformer: false,
      imageUrl: "https://randomuser.me/api/portraits/men/4.jpg",
    },
  ];

  return (
    <main>
      <Row className={` mt-2 mb-2`}>
        <div className="mb-2">
          <SubTitle text="Sales" />
        </div>

        {cardData.map((card, index) => (
          <Col
            key={index}
            className="mt-2 mb-2"
            lg={card?.lg}
            md={card?.lg}
            sm={6}
          >
            <SalesCard
              loading={dummyFetch.isLoading}
              bg1={bg1}
              bg2={bg2}
              icon={card.icon}
              number={card.number ?? 100}
              text={card.text}
              before_number={card.before_number}
              after_number={card.after_number}
              percentage={card.percentage}
              bottomText={card.bottomText}
              isTime={card.isTime}
            />
          </Col>
        ))}
      </Row>
      <div className="mb-2">
        <SubTitle text="Agent Scorecards" />
      </div>

      <Row>
        {dummyFetch.isLoading
          ? Array.from({ length: 4 }).map((data, index) => (
              <Col className="mt-2 mb-2" lg={6} sm={12}>
                <AgentProfileScoreCardSkeleton />
              </Col>
            ))
          : teamProfiles.map((profile, index) => (
              <Col className="mt-2 mb-2" lg={6} sm={12}>
                <AgentProfileScoreCard key={index} profile={profile} />
              </Col>
            ))}
      </Row>
    </main>
  );
};

export default SalesManagementScreen;
